/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Quadric scale
 * @module echarts/scale/Quadric
 */

import * as zrUtil from 'zrender/src/core/util';
import Scale from './Scale';
import * as numberUtil from '../util/number';

// Use some method of IntervalScale
import IntervalScale from './Interval';

var baseProto = IntervalScale.prototype;

let mathQuadric = (length, median, value) => {
    let lambda = Math.log(0.5) / median;
    let endpoint = 1 - Math.exp(lambda);
    return (1 - Math.exp(value / length * lambda)) / endpoint;
}

var QuadricScale = IntervalScale.extend({

    type: 'quadric',

    median: 0.1,

    /**
     * @return {Array.<number>}
     */
    getTicks: function () {
        return this.ticks ? this.ticks : baseProto.getTicks.call(this);
    },

    /**
     * Update interval and extent of intervals for nice ticks
     * @param  {number} [approxTickNum = 10] Given approx tick number
     */
    //niceTicks: ,

    /**
     * Nice extent.
     * @override
     */
    //niceExtent: 

});

zrUtil.each(['contain', 'normalize'], function (methodName) {
    QuadricScale.prototype[methodName] = function (val) {
        var extent = this.getExtent.call(this);
        let val1 = mathQuadric(extent[1], this.median, val);
        return val1;
    };
});

QuadricScale.create = function () {
    return new QuadricScale();
};

export default QuadricScale;